import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useWorkspacePanel } from '../panels/hooks/use-workspace-panel';
import { useEntityPanelManager } from '../panels/entity-panels/monitored-entities/state/entity-panel-manager';
import { AttachmentsPanelType } from './types';

export const AttachmentsManagerRegister = observer(function AttachmentsManagerRegister() {
    const entityPanelManager = useEntityPanelManager();
    const workspacePanel = useWorkspacePanel();

    const entityType = workspacePanel.linkedEntityType === 'BOLO' ? 'BOLO' : 'EVENT';
    const entityId = workspacePanel.linkedEntityId;

    // currently get search from entityPanelManager is for debugging purposes only.
    // TODO: media attachments get entityNumber from event or bolo panel bootstrap, like eventMetadata and useBoloPanelMetadata.
    let entityNumber = '';
    if (entityId && entityType === 'EVENT') {
        const eventPanel = entityPanelManager.eventPanelsList.find((p) => p.eventId === entityId);
        const historicalEvent = entityPanelManager.historicalEventPanelsList.find(
            (p) => p.eventId === entityId
        );
        entityNumber =
            eventPanel?.metadata?.agencyEventNumber || historicalEvent?.agencyEventNumber || '';
    } else if (entityId && entityType === 'BOLO') {
        const boloPanel = entityPanelManager.boloPanelList.find((p) => p.boloId === entityId);
        const historicalBolo = entityPanelManager.historicalBoloPanelsList.find(
            (p) => p.boloId === entityId
        );
        entityNumber = boloPanel?.metadata?.boloNumber || historicalBolo?.boloNumber || '';
    }

    useEffect(() => {
        if (entityId) {
            entityPanelManager.setAttachmentsPanel(workspacePanel.uuid, {
                entityId,
                entityType: entityType as AttachmentsPanelType,
                metadata: {
                    lastUpdatedDateUtc: new Date().toISOString(),
                    title: `Attachments - ${entityType} ${entityId}`,
                    entityId,
                    entityType: entityType as AttachmentsPanelType,
                    entityNumber,
                },
                workspacePanel,
            });
        }

        return () => {
            entityPanelManager.removeAttachmentsPanel(workspacePanel.uuid);
        };
    }, [entityPanelManager, workspacePanel, entityId, entityType, entityNumber]);

    return null;
});
